export const marketingModal = () => {
    const modal = document.querySelector('.marketing-modal');
    const scrollDisabledAttribute = 'scroll-disable';
    const cookieName = 'SuppressMarketingModal';
    const emailField = document.querySelector('.marketing-modal__email-input');
    const emailErrorField = document.querySelector('.marketing-modal__error');
    const emailErrorMessageField = document.querySelector('.marketing-modal__error-message');
    const emailErrorMessageEmptyField = document.querySelector('.marketing-modal__error-message-empty');
    const emailValidationRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const eventName = 'popUpModal';
    const loggedOutEventCategory = 'Sign Up - New';
    const loggedInEventCategory = 'Sign Up - Existing';
    const marketingPreferencesCallbackUrl = '/api/accountsapi/MarketingPreferences';
    const marketingSubmitEmailLoggedInCallbackUrl = '/marketingmodal/SubmitLoggedInEmail';
    const marketingSubmitEmailLoggedOutCallbackUrl = '/marketingmodal/SubmitLoggedOutEmail';
    const emailInput = document.querySelector(".marketing-modal__email-input");
    const signMeUp = document.querySelector(".marketing-modal__button__logged-in");

    const eventCategoryResolve = () => {
        return modal.id === 'logged-out-modal' ? loggedOutEventCategory : loggedInEventCategory;
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Escape') {
            close();
        } else if (event.key === 'Tab') {
            handleFocus(event);
        }
    };

    const showModalAfterDelay = () => {
        if (modal) {
            modal.classList.add('marketing-modal__visible');
            document.body.setAttribute(scrollDisabledAttribute, '');
            fireDataLayerEvent('impression', null);
        }
    };

    const focusOnFirstElement = (e) => {
        if (modal.classList.contains("marketing-modal__visible") && e.key === 'Tab') {
            if (emailInput) {
                e.preventDefault();
                emailInput.focus();
                document.removeEventListener("keydown", focusOnFirstElement);
            }
            else if (signMeUp) {
                e.preventDefault();
                signMeUp.focus();
                document.removeEventListener("keydown", focusOnFirstElement);
            }
        }
    };

    const onClickAddEventListener = () => {
        document.addEventListener("keydown", focusOnFirstElement);
    }

    const close = () => {
        if (modal) {
            modal.classList.remove('marketing-modal__visible');
            document.body.removeAttribute(scrollDisabledAttribute);
            setCookie();
            fireDataLayerEvent('close', null)
        }
        document.removeEventListener('keydown', handleKeyPress);
    };

    const addCloseEvent = () => {
        const button = document.querySelector('.marketing-modal__close-button');

        if (button) {
            button.addEventListener('click', close);
            document.addEventListener('keydown', handleKeyPress);
        }
    };

    const addHideErrorEvent = () => {
        emailField && emailField.addEventListener('input', hideError);
    };

    const hideError = () => {
        emailField.removeAttribute('aria-describedby');
        emailErrorField.setAttribute('hidden', true);
        emailErrorMessageField.setAttribute('hidden', true);
        emailErrorMessageEmptyField.setAttribute('hidden', true);
    };

    const submitLoggedInEmail = () => {
        const request = new Request(marketingSubmitEmailLoggedInCallbackUrl, { method: "POST" });
        fetch(request);
    }

    const submitLoggedOutEmail = () => {
        let urlParameters = new URLSearchParams();
        urlParameters.append('emailAddress', emailField.value);
        const request = new Request(marketingSubmitEmailLoggedOutCallbackUrl + `?${urlParameters}`, { method: "POST" });
        fetch(request);
    }

    const submitLoggedOut = () => {
        if (emailValidationRegex.test(emailField.value)) {
            modal.classList.remove('marketing-modal__visible');
            document.body.removeAttribute(scrollDisabledAttribute);
            document.removeEventListener('keydown', handleKeyPress);
            setCookie();
            submitLoggedOutEmail();
            fireDataLayerEvent('success', null);
        } else {
            emailField.setAttribute('aria-describedby', 'marketing-modal__error');
            emailErrorField.removeAttribute('hidden');
            if (emailField.value.length > 0) {
                emailErrorMessageField.removeAttribute('hidden');
            } else {
                emailErrorMessageEmptyField.removeAttribute('hidden');
            }
            fireDataLayerEvent('error', emailErrorMessageField.getAttribute('hidden') !== null ? emailErrorMessageEmptyField.innerHTML.trim() : emailErrorMessageField.innerHTML.trim());
        }
    };

    const submitLoggedIn = () => {
        updateEmailPreferences();
        modal.classList.remove('marketing-modal__visible');
        document.body.removeAttribute(scrollDisabledAttribute);
        document.removeEventListener('keydown', handleKeyPress);
        setCookie();
        submitLoggedInEmail();
        fireDataLayerEvent('success', null);
    };

    const updateEmailPreferences = () => {
        const request = new Request(marketingPreferencesCallbackUrl, { method: "POST" });
        fetch(request);
    };

    const addLoggedOutSubmitEvent = () => {
        const button = document.querySelector('.marketing-modal__button__logged-out');

        if (button) {
            button.addEventListener('click', submitLoggedOut);
        }
    };

    const addLoggedInSubmitEvent = () => {
        const button = document.querySelector('.marketing-modal__button__logged-in');

        if (button) {
            button.addEventListener('click', submitLoggedIn);
        }
    };

    const fireDataLayerEvent = (action, label) => {
        if (label) {
            window.dataLayer.push({
                'event': eventName,
                'category': eventCategoryResolve(),
                'action': action,
                'label': label
            });
        } else {
            window.dataLayer.push({
                'event': eventName,
                'category': eventCategoryResolve(),
                'action': action
            });
        }
    };

    const setCookie = () => {
        const noOfDaysHideWindow = modal.dataset.noOfDaysHideWindow;
        if (noOfDaysHideWindow) {
            const d = new Date();
            d.setTime(d.getTime() + (parseInt(noOfDaysHideWindow) * 24 * 60 * 60 * 1000));
            const expires = `expires=${d.toUTCString()}`;
            document.cookie = `${cookieName}=true;${expires};path=/`;
        }
    };

    const handleFocus = (e) => {
        var target = document.activeElement;
        var shiftPressed = e.shiftKey;
        var targetableModalElements = document.querySelector('[role=dialog]').querySelectorAll('button,input');
        var borderElem = shiftPressed ? targetableModalElements[0] : targetableModalElements[targetableModalElements.length - 1];
        if (target === borderElem) {
            if (target === targetableModalElements[0] && shiftPressed) {
                e.preventDefault();
                targetableModalElements[targetableModalElements.length - 1].focus();
            } else {
                e.preventDefault();
                targetableModalElements[0].focus();
            }
        }
    }

    const init = () => {
        if (!modal) { return; }
        const noOfSeconds = modal.dataset.timeToDisplay;
        if (noOfSeconds) {
            setTimeout(showModalAfterDelay, parseInt(noOfSeconds) * 1000);
        }
        addHideErrorEvent();
        addCloseEvent();
        addLoggedOutSubmitEvent();
        addLoggedInSubmitEvent();
        
        document.addEventListener("keydown", focusOnFirstElement);
        document.addEventListener("click", onClickAddEventListener);
    };

    return {
        init
    };
}
